import React from 'react';

interface AccordionProps {
  accordionTitle: string;
  children: React.ReactNode;
  index: number;
  openAccordion: number | null;
  setOpenAccordion: (index: number | null) => void;
}

const CustomAccordion = ({
  accordionTitle,
  children,
  index,
  openAccordion,
  setOpenAccordion,
}: AccordionProps) => {
  const isOpen = openAccordion === index;

  return (
    <div className="w-full border-b border-gray-50">
      {/* Header */}
      <button
        type="button"
        onClick={() => setOpenAccordion(isOpen ? null : index)}
        className="flex items-center justify-between w-full py-3 "
      >
        <span className="text-sm font-medium text-right text-gray-800">
          <span className="relative text-gray-800 text-xxl -top-0">. </span>
          {accordionTitle}
        </span>

        {/* Chevron Icon */}
        <svg
          className={`w-4 h-4 text-gray-600 transition-transform duration-300 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Content */}
      <div
        className={`transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-2 py-2">{children}</div>
      </div>
    </div>
  );
};

export default CustomAccordion;
